import type { PanelResizeCorner } from "@/shared/hooks/useDraggablePanel";

/**
 * 描画順。DOM順がそのままフォーカス順になるため、視覚的な読み順
 * (左上 → 左下 → 右下) に揃えている。
 */
export const RESIZE_CORNERS: readonly PanelResizeCorner[] = [
  "top-left",
  "bottom-left",
  "bottom-right",
];

const CORNER_NAMES: Record<PanelResizeCorner, string> = {
  "top-left": "左上",
  "bottom-left": "左下",
  "bottom-right": "右下",
};

export function describeResizeCorner(corner: PanelResizeCorner): string {
  return CORNER_NAMES[corner];
}

/** 隅ごとに一意なアクセシブル名を組み立てる。 */
export function buildResizeCornerLabel(
  panelLabel: string,
  corner: PanelResizeCorner,
): string {
  return `${panelLabel}のサイズを変更（${describeResizeCorner(corner)}）`;
}
